/* Publish by EComposer at 2026-10-01 15:43:43*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-u6nvrgkvkip"]=  window.__ectimmers["ecom-u6nvrgkvkip"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-u6nvrgkvkip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u6nvrgkvkip', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dpn1zfngf55').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dpn1zfngf55', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ff5ccg928sl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ff5ccg928sl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqp8afw6v9d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqp8afw6v9d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tnqxz3qcudp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tnqxz3qcudp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9bvd7khzj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9bvd7khzj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z2n7f8tc84h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z2n7f8tc84h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pb86klj37s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pb86klj37s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gyefxyx3rpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gyefxyx3rpj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hipkckvsw6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hipkckvsw6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rbab2wikc6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rbab2wikc6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kwf74olbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kwf74olbi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwdr2imephg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwdr2imephg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wehxop46ei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wehxop46ei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxo3q1gx1z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxo3q1gx1z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cohplrtxrzl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cohplrtxrzl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5cb7oplypo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5cb7oplypo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0gmfyu3y9ch5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0gmfyu3y9ch5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24x2iadzzu8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24x2iadzzu8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9vxdy63eigp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9vxdy63eigp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mh84zva8n8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mh84zva8n8s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfp3dl20m7n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfp3dl20m7n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fngizp74zgw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fngizp74zgw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2wgkf3tbcs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2wgkf3tbcs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2cv70gcgqog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cv70gcgqog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98ihbiapaoh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98ihbiapaoh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-533pztuctcp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-533pztuctcp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qttgfc1xem').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qttgfc1xem', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0hf61el7r5x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0hf61el7r5x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nk5g621y9ih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nk5g621y9ih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gshpryhaood').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gshpryhaood', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8m2q69posn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8m2q69posn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvem792tdmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvem792tdmk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1flc0beqfdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1flc0beqfdh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ebseovzewjj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ebseovzewjj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5s5lb99wbp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5s5lb99wbp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nstetm53lvc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nstetm53lvc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sy2yevchhlr"]=  window.__ectimmers["ecom-sy2yevchhlr"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-sy2yevchhlr"]["bm1q9lywh"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-sy2yevchhlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sy2yevchhlr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2z1gmv8w72u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2z1gmv8w72u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7vyogmu4r8y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vyogmu4r8y', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3nj76529are').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3nj76529are', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a53uam12g9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a53uam12g9k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xqz2xc7m4ph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xqz2xc7m4ph', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izie820et1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izie820et1e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6vox96trd9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6vox96trd9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmyhg3ph5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmyhg3ph5d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gaukkrrsy74').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gaukkrrsy74', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9nr9hyqym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9nr9hyqym', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tho3p5xej6s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tho3p5xej6s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k20s79gc6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k20s79gc6d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lv0yess2d2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lv0yess2d2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ftsrrn8p96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ftsrrn8p96', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zwvkniec8y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zwvkniec8y', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0py8tas87xr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0py8tas87xr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5wq9boiv7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5wq9boiv7g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uhwg7qz5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uhwg7qz5o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ba2d6v82qsw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ba2d6v82qsw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zdo50vtzgl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zdo50vtzgl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qm7c1uni6sr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qm7c1uni6sr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t3hnkz2fymp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t3hnkz2fymp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aezl417f6qj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aezl417f6qj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i5l1nyplf4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i5l1nyplf4p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsp8wedks06').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsp8wedks06', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znxvf97o4c8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znxvf97o4c8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ndu395utckk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ndu395utckk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ialuxtvf05i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ialuxtvf05i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrni6vdg9zm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrni6vdg9zm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdww7997qvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdww7997qvf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vk9ut9u1fl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vk9ut9u1fl', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pgssql47ux"]=  window.__ectimmers["ecom-pgssql47ux"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-pgssql47ux').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgssql47ux', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2l4788sb3dh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l4788sb3dh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbytyrqccmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbytyrqccmf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2roersajjc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2roersajjc9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d0fj43v0bmg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d0fj43v0bmg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjncai0nmm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjncai0nmm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wpp6ina0mzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wpp6ina0mzo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1rspaj9zryu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1rspaj9zryu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5w1ak68q15o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5w1ak68q15o', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ak7y7p3erd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ak7y7p3erd', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qj6mmj094kq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qj6mmj094kq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e84ag6nd6zv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e84ag6nd6zv', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g1ptyalma2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g1ptyalma2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1iwlig04gc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1iwlig04gc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rh25dsxt69d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rh25dsxt69d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-owmjgayq8qr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-owmjgayq8qr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ouhh9rtmbl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ouhh9rtmbl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a0z47eg56j4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0z47eg56j4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qyssr874n1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qyssr874n1', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qr6rsaysjei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qr6rsaysjei', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3vc1u4vwuo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3vc1u4vwuo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yyw7oomqrhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yyw7oomqrhn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u0e9tpobbof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u0e9tpobbof', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lcfznu3la5b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lcfznu3la5b', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}